export const Paging = {
    PAGE_SIZE: 120,
    SKU_SEARCH_PAGE_SIZE: 100,
    LARGE_VIEWPORT_PAGE_THRESHOLD: 2,
};
